<template>
  <div class="contenedor">
  <div class="opcion">
    <v-btn color="blue" fab height="80" width="80" to="profile">
      <v-icon color="white" size="36">mdi-account-circle</v-icon>
    </v-btn>
    <span class="texto">Mi Perfil</span>
 </div>
  <div class="opcion">
      <v-btn color="blue" fab height="80px" width="80px" to="financial">
        <v-icon color="white" size="36">mdi-account-cash</v-icon>     
      </v-btn>
       <span class="texto">Pagos y Comprobantes</span>
  </div>
  <div class="opcion">
      <v-btn color="blue" fab height="80px" width="80px" to="events">
        <v-icon color="white" size="36">mdi-clock-check</v-icon>
      </v-btn>
      <span class="texto">Reserva de Amenidades</span>
  </div>
  <div class="opcion">
      <v-btn color="blue" fab height="80px" width="80px" to="regulations">
        <v-icon color="white" size="36">mdi-script-text-outline</v-icon>
      </v-btn>
      <span class="texto">Reglamentos Actas y Normas</span>
  </div>
  <div class="opcion">
      <v-btn color="blue" fab height="80px" width="80px" to="news-submenu">
        <v-icon color="white" size="36">mdi-bell-circle</v-icon>
      </v-btn>
      <span class="texto">Notificaciones y boletines</span>
  </div>
  <div class="opcion"><v-btn color="blue" fab height="80px" width="80px" to="myTickets">
        <v-icon color="white" size="36">mdi-ticket</v-icon>
      </v-btn>
      <span class="texto">Solicitudes a la Administración</span>
  </div>
</div>
</template>

<script>
export default {
  
  data() {
    return {
    };
  },
};
</script>

<style lang="scss">
@import './src/assets/style.scss';

.contenedor{
  height:100vh;
  display:flex;
  flex-wrap:wrap;
  justify-content:center;   /* centra horizontal */
  align-content:center;     /* centra vertical */
   position: fixed;
  top:0;
  left:0;
}

.opcion{
  width:50%;                /* 2 columnas */
  display:flex;
  justify-content:center;
  flex-direction:column;   /* agrega esto */
  align-items:center;
  font-size:30px;
  height:200px;             /* altura de cada fila */
 

}

.texto{
  margin-top:8px;
  font-size:14px;
  text-align: center;
  font-size: 16px !important;
  font-weight: bold !important;
  color: #00aff2 !important;
}
</style>
